import React from 'react';
import { useGetStorehouses } from 'api/counterparties';
import {
  GetStorehousesParams,
  Storehouse,
} from 'api/counterparties/counterparties.types';
import { EditableAutocomplete } from './EditableAutocomplete';

interface EditableLoadingDeliveryLocationAutocompleteProps {
  value: any;
  onChange: (value: any) => void;
  onSave: (value: any) => void;
  onCancel: () => void;
  customerId?: number | null;
  disableClearable?: boolean;
}

const formatStorehouseLabel = (o: Storehouse | string | any): string => {
  if (typeof o === 'string') return o;

  if (o && typeof o === 'object' && o.address) {
    const city = o.address.city || '';
    const lineTwo = o.address.lineTwo || '';

    if (city && lineTwo) {
      return `${city}, ${lineTwo}`;
    } else if (city) {
      return `${city}, -`;
    } else if (lineTwo) {
      return `-, ${lineTwo}`;
    }
    return '-, -';
  }

  if (o && typeof o === 'object' && 'code' in o && typeof o.code === 'string') {
    return o.code;
  }

  return '-, -';
};

export const EditableLoadingDeliveryLocationAutocomplete: React.FC<
  EditableLoadingDeliveryLocationAutocompleteProps
> = ({ customerId, disableClearable = false, ...props }) => (
  <EditableAutocomplete<Storehouse, GetStorehousesParams>
    {...props}
    disableClearable={disableClearable}
    disabled={!customerId}
    useApiHook={useGetStorehouses}
    getterName='getStorehouses'
    additionalDependency={customerId}
    skipFetchCondition={() => !customerId}
    defaultParams={{
      filterText: '',
      resultSize: 1000,
      pageNumber: 1,
    }}
    getOptionLabel={formatStorehouseLabel}
    isOptionEqualToValue={(option, selectedValue) => {
      return (
        formatStorehouseLabel(option) === formatStorehouseLabel(selectedValue)
      );
    }}
    width={200}
  />
);
